export const ONBOARDING_API_PATTERN = /\/api\/(?:admin\/)?onboarding(?:\/|[?#]|$)/i;
export function isOnboardingPrivateUrl(value: string): boolean {
  let decoded = value;
  for (let i = 0; i < 3; i += 1) {
    try {
      decoded = decodeURIComponent(decoded);
    } catch {
      break;
    }
  }
  return (
    ONBOARDING_API_PATTERN.test(decoded) ||
    /\/(?:register\/onboarding|dashboard\/admin\/(?:onboarding|registrations))(?:\/|[?#]|$)/i.test(decoded)
  );
}
/** Drop events entirely, including errors without URLs while the private panel is open. */
export function filterOnboardingTelemetry<T>(
  event: T,
  path = typeof window === 'undefined' ? '' : window.location.pathname
): T | null {
  if (isOnboardingPrivateUrl(path)) return null;
  const seen = new WeakSet<object>();
  const contains = (value: unknown): boolean => {
    if (typeof value === 'string') return isOnboardingPrivateUrl(value);
    if (!value || typeof value !== 'object' || seen.has(value)) return false;
    seen.add(value);
    return Object.values(value).some(contains);
  };
  return contains(event) ? null : event;
}
